/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateWorkflowtaskDto } from '../models/work-create-workflowtask-dto';
import { WorkUpdateWorkflowtaskDto } from '../models/work-update-workflowtask-dto';
import { WorkUpdateWorkflowtaskSortableRankDto } from '../models/work-update-workflowtask-sortable-rank-dto';
import { WorkWorkflowtask } from '../models/work-workflowtask';

@Injectable({ providedIn: 'root' })
export class WorkWorkflowtasksV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `workflowtasksV2ControllerFindAllByWorkflowId()` */
  static readonly WorkflowtasksV2ControllerFindAllByWorkflowIdPath = '/v2/workflowtasks/{workflowId}';

  /**
   * Required permissions: workflows:read, workflows:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `workflowtasksV2ControllerFindAllByWorkflowId()` instead.
   *
   * This method doesn't expect any request body.
   */
  workflowtasksV2ControllerFindAllByWorkflowId$Response(
    params: {
      workflowId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkWorkflowtask>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkWorkflowtasksV2Service.WorkflowtasksV2ControllerFindAllByWorkflowIdPath, 'get');
    if (params) {
      rb.path('workflowId', params.workflowId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkWorkflowtask>>;
      })
    );
  }

  /**
   * Required permissions: workflows:read, workflows:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `workflowtasksV2ControllerFindAllByWorkflowId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  workflowtasksV2ControllerFindAllByWorkflowId(
    params: {
      workflowId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkWorkflowtask>> {
    return this.workflowtasksV2ControllerFindAllByWorkflowId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkWorkflowtask>>): Array<WorkWorkflowtask> => r.body)
    );
  }

  /** Path part for operation `workflowtasksV2ControllerCreate()` */
  static readonly WorkflowtasksV2ControllerCreatePath = '/v2/workflowtasks';

  /**
   * Required permissions: workflows:create, workflows:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `workflowtasksV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  workflowtasksV2ControllerCreate$Response(
    params: {
      body: WorkCreateWorkflowtaskDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkWorkflowtask>> {
    const rb = new RequestBuilder(this.rootUrl, WorkWorkflowtasksV2Service.WorkflowtasksV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkWorkflowtask>;
      })
    );
  }

  /**
   * Required permissions: workflows:create, workflows:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `workflowtasksV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  workflowtasksV2ControllerCreate(
    params: {
      body: WorkCreateWorkflowtaskDto
    },
    context?: HttpContext
  ): Observable<WorkWorkflowtask> {
    return this.workflowtasksV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkWorkflowtask>): WorkWorkflowtask => r.body)
    );
  }

  /** Path part for operation `workflowtasksV2ControllerDelete()` */
  static readonly WorkflowtasksV2ControllerDeletePath = '/v2/workflowtasks/{id}';

  /**
   * Required permissions: workflows:delete, workflows:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `workflowtasksV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  workflowtasksV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkWorkflowtasksV2Service.WorkflowtasksV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: workflows:delete, workflows:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `workflowtasksV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  workflowtasksV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.workflowtasksV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `workflowtasksV2ControllerUpdate()` */
  static readonly WorkflowtasksV2ControllerUpdatePath = '/v2/workflowtasks/{id}';

  /**
   * Required permissions: workflows:update, workflows:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `workflowtasksV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  workflowtasksV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateWorkflowtaskDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkWorkflowtask>> {
    const rb = new RequestBuilder(this.rootUrl, WorkWorkflowtasksV2Service.WorkflowtasksV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkWorkflowtask>;
      })
    );
  }

  /**
   * Required permissions: workflows:update, workflows:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `workflowtasksV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  workflowtasksV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateWorkflowtaskDto
    },
    context?: HttpContext
  ): Observable<WorkWorkflowtask> {
    return this.workflowtasksV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkWorkflowtask>): WorkWorkflowtask => r.body)
    );
  }

  /** Path part for operation `workflowtasksV2ControllerUpdateSortableRankForTaskGroup()` */
  static readonly WorkflowtasksV2ControllerUpdateSortableRankForTaskGroupPath = '/v2/workflowtasks/workflowtasks/sortableRanks';

  /**
   * Required permissions: workflows:update, workflows:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `workflowtasksV2ControllerUpdateSortableRankForTaskGroup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  workflowtasksV2ControllerUpdateSortableRankForTaskGroup$Response(
    params: {
      body: Array<WorkUpdateWorkflowtaskSortableRankDto>
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, WorkWorkflowtasksV2Service.WorkflowtasksV2ControllerUpdateSortableRankForTaskGroupPath, 'patch');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Required permissions: workflows:update, workflows:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `workflowtasksV2ControllerUpdateSortableRankForTaskGroup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  workflowtasksV2ControllerUpdateSortableRankForTaskGroup(
    params: {
      body: Array<WorkUpdateWorkflowtaskSortableRankDto>
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.workflowtasksV2ControllerUpdateSortableRankForTaskGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
